import { HelpersServiceModule } from '@b2c/common/services/helpers/helpers.service';
import angular from 'angular';

export const PageDetailsDirectiveModule = angular.module('acme.common.directive.page.details', [HelpersServiceModule])
  .directive('pageDetails', [function() {

    return {
      restrict: 'A',
      replace: true,
      transclude: true,
      templateUrl: 'common/directives/page/details/details.tpl.html',
      scope: {
        wide: '@',
        unsafe: '@',
        description: '='
      },

      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', '$sce', 'HelpersService', function($scope, $sce, HelpersService) {

        $scope.pageDetails = {

          unsafeDescription: '',

          init: function() {
            this.updateDescription();

            $scope.$watch('description', this.onDescriptionUpdate);
          },

          updateDescription: function() {
            if ($scope.unsafe) {
              this.unsafeDescription = $sce.trustAsHtml(HelpersService.convertBreaks($scope.description));
            }
          },

          onDescriptionUpdate: function(n, o) {
            $scope.pageDetails.updateDescription();
          }

        };

        $scope.pageDetails.init();

      }]

    };

  }]).name;